var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2V6.5M30.5 2V6.5M2 33.5V11C2 9.80653 2.47411 8.66193 3.31802 7.81802C4.16193 6.97411 5.30653 6.5 6.5 6.5H33.5C34.6935 6.5 35.8381 6.97411 36.682 7.81802C37.5259 8.66193 38 9.80653 38 11V33.5M2 33.5C2 34.6935 2.47411 35.8381 3.31802 36.682C4.16193 37.5259 5.30653 38 6.5 38H33.5C34.6935 38 35.8381 37.5259 36.682 36.682C37.5259 35.8381 38 34.6935 38 33.5M2 33.5V18.5C2 17.3065 2.47411 16.1619 3.31802 15.318C4.16193 14.4741 5.30653 14 6.5 14H33.5C34.6935 14 35.8381 14.4741 36.682 15.318C37.5259 16.1619 38 17.3065 38 18.5V33.5",
    stroke: "#28414B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26H32M32 26L25.7876 20M32 26L25.7876 32",
    stroke: "#28414B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollOver);
export default __webpack_public_path__ + "static/media/roll-over.f6d75bf94b37ae612dab5f33bd5c5d51.svg";
export { ForwardRef as ReactComponent };